import parseColor from "parse-color";
import { AppColorPalette } from "../components/__generated__/MobilePreviewQuery.graphql";
import { AppColorPaletteTransparent } from "../components/ColorDropdownSelector";

export type BrandColorPalette = {
  primary: string;
  accent1: string;
  accent2: string;
  accent3: string;
  background1: string;
  background2: string;
};

const DEFAULT_COLORS = {
  BLACK: "#000000",
  WHITE: "#FFFFFF",
  GRAY: "#ECECEC",
  TRANSPARENT: "transparent",
} as const;

export const getBrandColorToAppColorPalette = (
  palette: BrandColorPalette
): Record<string, AppColorPalette> => {
  return {
    [DEFAULT_COLORS.BLACK]: "BLACK",
    [DEFAULT_COLORS.WHITE]: "WHITE",
    [DEFAULT_COLORS.GRAY]: "GRAY",
    [palette.accent3.toUpperCase()]: "ACCENT_3",
    [palette.accent2.toUpperCase()]: "ACCENT_2",
    [palette.accent1.toUpperCase()]: "ACCENT_1",
    [palette.primary.toUpperCase()]: "PRIMARY",
  };
};

const isBrandColorPalette = (
  palette: BrandColorPalette | Record<string, AppColorPalette>
): palette is BrandColorPalette => {
  return "primary" in palette;
};

export const getBrandToAppColorPalette = ({
  color,
  palette,
}: {
  color: string;
  palette: BrandColorPalette | Record<string, AppColorPalette>;
}): AppColorPalette | null => {
  const brandHexToApp = isBrandColorPalette(palette)
    ? getBrandColorToAppColorPalette(palette)
    : palette;
  const colorHex = parseColor(color).hex.toUpperCase();
  return brandHexToApp[colorHex] || null;
};

const getColorMapping = (
  palette: AppColorPaletteTransparent | null,
  primary: string,
  accent1: string,
  accent2: string,
  accent3: string,
  background1: string = "",
  background2: string = ""
): string => {
  switch (palette) {
    case "PRIMARY":
      return primary;
    case "ACCENT_1":
      return accent1;
    case "ACCENT_2":
      return accent2;
    case "ACCENT_3":
      return accent3;
    case "BACKGROUND_1":
      return background1;
    case "BACKGROUND_2":
      return background2;
    case null:
      return "";
    default:
      return DEFAULT_COLORS[palette as keyof typeof DEFAULT_COLORS] || "";
  }
};

export default getColorMapping;
